export const PERMISSION_RESOURCE_CODES = {
  manageEntry: 'manage-entry',
  manageWorkbench: 'manage-workbench',
  manageCourse: 'manage-course',
  manageCourseDetail: 'manage-course-detail',
  managePlan: 'manage-plan',
  managePlanDetail: 'manage-plan-detail',
  manageRecords: 'manage-records',
  manageStatistics: 'manage-statistics',
  managePermission: 'manage-permission',
} as const;

export const PERMISSION_ACTION_CODES = {
  manageEntry: {
    view: 'view',
  },
  manageWorkbench: {
    view: 'view',
  },
  manageCourse: {
    view: 'view',
    query: 'query',
    search: 'search',
    filter: 'filter',
    create: 'create',
    edit: 'edit',
  },
  manageCourseDetail: {
    view: 'view',
    edit: 'edit',
    create: 'create',
    upload: 'upload',
    delete: 'delete',
    submit: 'submit',
    disable: 'disable',
    manage: 'manage',
    download: 'download',
  },
  managePlan: {
    view: 'view',
    query: 'query',
    search: 'search',
    filter: 'filter',
    create: 'create',
    edit: 'edit',
  },
  managePlanDetail: {
    view: 'view',
    create: 'create',
    edit: 'edit',
    submit: 'submit',
  },
  manageRecords: {
    view: 'view',
    query: 'query',
    search: 'search',
    filter: 'filter',
  },
  manageStatistics: {
    view: 'view',
  },
  managePermission: {
    view: 'view',
  },
} as const;

export type PermissionResourceCode =
  (typeof PERMISSION_RESOURCE_CODES)[keyof typeof PERMISSION_RESOURCE_CODES];
